import APIURL from "../axios";

export const InStayShopSubMenuAPI = async ({
  room_uuid,
  selected,
  pageParam,
  lang,
}) => {
  return await APIURL.get(
    `/${room_uuid}/in-stay-shop?${selected ? `cat=${selected}&` : ""}page=${pageParam}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: lang,
      },
    }
  );
};

export const InStayShopCategoriesAPI = async ({ room_uuid, cat, lang }) => {
  return await APIURL.get(
    `/${room_uuid}/in-stay-shop/categories${cat ? `?cat=${cat}` : ""}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: lang,
      },
    }
  );
};

export const InStayShopProductAPI = async ({ room_uuid, product_id, lang }) => {
  return await APIURL.get(
    `/${room_uuid}/in-stay-shop/product/${product_id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: lang,
      },
    }
  );
};
